import ActionType from '../enums/ActionType';

export default function actionType(value: string): string {

    switch(value) {

        case ActionType.HARVEST: return 'Verzaaien';
        case ActionType.FISHING_AUCTION: return 'Levering';
        case ActionType.SAMPLE: return 'Monstering';
        case ActionType.SOWING: return 'Gezaaid';
        case ActionType.TREATMENT: return 'Behandeling';
        case ActionType.TREATMENT_SOWING: return 'Zaaibehandeling';
        case ActionType.TREATMENT_HARVEST: return 'Oogstbehandeling';
        default: return '-';
    }
}
